<h1 mat-dialog-title>Einstellungen</h1>
<mat-divider></mat-divider>
<mat-dialog-content [formGroup]="settingsForm">
    <div>
        <mat-checkbox formControlName="coloredTableButtons">Farbige Aktionen-Schaltflächen in Tabellen</mat-checkbox>
    </div>
    <div>
        <mat-checkbox formControlName="frostedGlass">Hintergrund weichzeichnen</mat-checkbox>
    </div>
    <div class="pixl-language-switcher"><pixl-language-switcher></pixl-language-switcher>&nbsp;Sprache</div>
</mat-dialog-content>
<mat-divider></mat-divider>
<mat-dialog-actions>
    <button
        mat-raised-button
        (click)="onCancel()"
    >Abbruch</button>
    <button
        mat-raised-button
        (click)="onSave()"
    >Speichern</button>
</mat-dialog-actions>